<template>
  <ClientOnly v-if="disableContentSSR">
    <EditableArea :content="main" />
    <template #fallback>
      <LoadingElement class="aspect-video" />
    </template>
  </ClientOnly>
  <EditableArea v-else :content="main" />
</template>

<script setup>
// todo: rework to composition API
import { EditableArea } from "@magnolia/vue-editor";
import LoadingElement from "~/templates/elements/LoadingElement.vue";
const props = defineProps(["title", "metadata", "main", "disableContentSSR"]);

defineOptions({
  inheritAttrs: false,
});
</script>

<script>
import { editableComponent } from "~/utils/mixins/editableComponent";

export default {
  name: "BasicPage",
  mixins: [editableComponent],

  data() {
    return {
      context: null,
    };
  },
};
</script>
